const mainStoreDomain = 'aroma360.com';

const getCookieValueKlv = (name) => document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''

// Store cookie across subdomains
let writeCookieKlv = function (cname, cvalue, days) {
  // console.log('writeCookie')
  var dt, expires
  dt = new Date()
  dt.setTime(dt.getTime() + days * 24 * 60 * 60 * 1000)
  expires = '; expires=' + dt.toGMTString()
  document.cookie = cname + '=' + cvalue + expires + `;domain=.${mainStoreDomain};path=/`
}


function klaviyoTabSwitchTracker() {
    let currentUrl = window.location.href.split('.com')[0].split('//')[1]
    let currentStore;
    if (currentUrl == 'perfumeandbody.aroma360') {
        currentStore = 'PB'
    } else {
        currentStore = 'Aroma'
    }
    const currentStoreFromCookie = getCookieValueKlv('current-store')
   // console.log('klaviyoTabSwitchTracker', currentStore, currentStoreFromCookie)
    if (currentStoreFromCookie && currentStore !== currentStoreFromCookie) {
        // window._learnq.push(['track', 'Store Switch', currentStore]);
        klaviyo.track(`Store Switched to ${currentStore}`)
      // console.log('store switched')
    }
    writeCookieKlv('current-store', currentStore, 10)
}

klaviyoTabSwitchTracker()